import React from 'react';
import PropTypes from 'prop-types';
import { getPrivacyConsentLabel } from "../../../utils/get-privacy-consent-label";
import { ACCEPT_PRIVACY_POLICY, CALL_ME_BACK, DATE, EMAIL, FORM_PROTECTION, NAME, NOTES, PHONE, PROPERTY, SEND, TIME } from "../../../utils/default-strings";
import { Dropdown } from "../../inputs/Dropdown";
import { Form } from "../../collections/Form";
import { ICON_NAMES } from "../../elements/Icon";
import { InputGroup } from "../../collections/InputGroup";
import { PhoneInput } from "../../inputs/PhoneInput";
import { SingleDatePicker } from "../../inputs/SingleDatePicker";
import { TextArea } from "../../inputs/TextArea";
import { TextInput } from "../../inputs/TextInput";
import { Checkbox } from "../../inputs/Checkbox";
import { EMAIL_MAX_CHARACTERS, NAME_MAX_CHARACTERS, NOTES_MAX_CHARACTERS, PHONE_MAX_CHARACTERS } from "./constants";
export var Component = function Component(_ref) {
  var botProtectionMessage = _ref.botProtectionMessage,
      dateInputPlaceholder = _ref.dateInputPlaceholder,
      emailInputLabel = _ref.emailInputLabel,
      errorMessage = _ref.errorMessage,
      headingText = _ref.headingText,
      isBotProtected = _ref.isBotProtected,
      isPrivacyConsentRequired = _ref.isPrivacyConsentRequired,
      nameInputLabel = _ref.nameInputLabel,
      notesInputLabel = _ref.notesInputLabel,
      onSubmit = _ref.onSubmit,
      phoneInputCountryNames = _ref.phoneInputCountryNames,
      phoneInputInitialCountryValue = _ref.phoneInputInitialCountryValue,
      phoneInputLabel = _ref.phoneInputLabel,
      privacyConsentLabelText = _ref.privacyConsentLabelText,
      privacyConsentLabelLinkText = _ref.privacyConsentLabelLinkText,
      privacyConsentLabelLinkUrl = _ref.privacyConsentLabelLinkUrl,
      propertyInputLabel = _ref.propertyInputLabel,
      propertyOptions = _ref.propertyOptions,
      submitButtonText = _ref.submitButtonText,
      successMessage = _ref.successMessage,
      timeInputLabel = _ref.timeInputLabel,
      timeOptions = _ref.timeOptions,
      validation = _ref.validation;
  return React.createElement(Form, {
    autoComplete: "off",
    errorMessage: errorMessage,
    headingText: headingText,
    onSubmit: onSubmit,
    submitButtonText: submitButtonText,
    successMessage: successMessage,
    validation: validation
  }, React.createElement(InputGroup, null, React.createElement(TextInput, {
    autoComplete: "name",
    label: nameInputLabel,
    maxCharacters: NAME_MAX_CHARACTERS,
    name: "name"
  }), React.createElement(PhoneInput, {
    autoComplete: "tel",
    countryNames: phoneInputCountryNames,
    initialCountryValue: phoneInputInitialCountryValue,
    label: phoneInputLabel,
    maxCharacters: PHONE_MAX_CHARACTERS,
    name: "phone"
  })), React.createElement(TextInput, {
    autoComplete: "email",
    label: emailInputLabel,
    maxCharacters: EMAIL_MAX_CHARACTERS,
    name: "email"
  }), React.createElement(InputGroup, null, React.createElement(SingleDatePicker, {
    name: "date",
    placeholderText: dateInputPlaceholder
  }), React.createElement(Dropdown, {
    icon: ICON_NAMES.CLOCK,
    label: timeInputLabel,
    name: "time",
    options: timeOptions
  })), propertyOptions && React.createElement(Dropdown, {
    label: propertyInputLabel,
    name: "property",
    options: propertyOptions
  }), React.createElement(TextArea, {
    label: notesInputLabel,
    maxCharacters: NOTES_MAX_CHARACTERS,
    name: "notes"
  }), isBotProtected && botProtectionMessage, isPrivacyConsentRequired && React.createElement(Checkbox, {
    label: getPrivacyConsentLabel(privacyConsentLabelText, privacyConsentLabelLinkUrl, privacyConsentLabelLinkText),
    name: "privacyConsent"
  }));
};
Component.displayName = 'CallMeBack';
Component.defaultProps = {
  botProtectionMessage: FORM_PROTECTION,
  dateInputPlaceholder: DATE,
  emailInputLabel: EMAIL,
  errorMessage: '',
  headingText: CALL_ME_BACK,
  isBotProtected: false,
  isPrivacyConsentRequired: false,
  nameInputLabel: NAME,
  notesInputLabel: NOTES,
  onSubmit: Function.prototype,
  phoneInputCountryNames: undefined,
  phoneInputInitialCountryValue: undefined,
  phoneInputLabel: PHONE,
  privacyConsentLabelText: ACCEPT_PRIVACY_POLICY,
  privacyConsentLabelLinkText: undefined,
  privacyConsentLabelLinkUrl: undefined,
  propertyInputLabel: PROPERTY,
  propertyOptions: null,
  submitButtonText: SEND,
  successMessage: '',
  timeInputLabel: TIME,
  validation: {}
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  botProtectionMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  dateInputPlaceholder: PropTypes.string,
  emailInputLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  headingText: PropTypes.string,
  isBotProtected: PropTypes.bool,
  isPrivacyConsentRequired: PropTypes.bool,
  nameInputLabel: PropTypes.string,
  notesInputLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  phoneInputCountryNames: PropTypes.objectOf(PropTypes.string),
  phoneInputInitialCountryValue: PropTypes.string,
  phoneInputLabel: PropTypes.string,
  privacyConsentLabelLinkText: PropTypes.string,
  privacyConsentLabelLinkUrl: PropTypes.string,
  privacyConsentLabelText: PropTypes.node,
  propertyInputLabel: PropTypes.string,
  propertyOptions: PropTypes.arrayOf(PropTypes.shape({
    indent: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })),
  submitButtonText: PropTypes.string,
  successMessage: PropTypes.string,
  timeInputLabel: PropTypes.string,
  timeOptions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })).isRequired,
  validation: PropTypes.shape({
    date: PropTypes.object,
    email: PropTypes.object,
    name: PropTypes.object,
    notes: PropTypes.object,
    phone: PropTypes.object,
    privacyConsent: PropTypes.object,
    property: PropTypes.object,
    time: PropTypes.object
  })
} : {};